import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractFormControl } from '../abstract-form-control';
import { BuildingAmenityData } from '@artemis-software/wr-api';

@Component({
  standalone: false,
  selector: 'wr-building-attic-select',
  templateUrl: './building-attic-select.component.html',
  styleUrls: ['./building-attic-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BuildingAtticSelectComponent),
      multi: true,
    },
  ],
})
export class BuildingAtticSelectComponent extends AbstractFormControl<BuildingAmenityData.ConvertedAtticEnum> {
  readonly BuildingAttic = BuildingAmenityData.ConvertedAtticEnum;
}
